webpackJsonp([12,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(203);
	module.exports = __webpack_require__(204);


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	var config = {
	  scheme: 'release',
	  env: {
	    alpha: {
	      prefix: ''
	    },
	    beta: {
	      prefix: '/admin',
	      apiPath: '/apiPath',
	      basicUrl: 'http://dev.lvyuetravel.com:8080',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    devx: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://dev.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
	      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    test: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://test.www.lvyuetravel.com',
	      aihuazhuUrl: 'http://test.www.aihuazhu.com',
	      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    integrate: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'http://www.integrate.lvyuetravel.com',
	      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
	      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=default'
	    },
	    production: {
	      prefix: '',
	      apiPath: '',
	      basicUrl: 'https://www.lvyuetravel.com',
	      aihuazhuUrl: 'https://www.aihuazhu.com',
	      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
	      senCondjs: 'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
	      senCond: 'https://shence.lvyuetravel.com/sa?project=production'
	    }
	  },
	  domains: {
	    urlStatic: '',
	    loginSite: 'http://test.www.lvyuetravel.com'
	  }
	};
	
	// 环境切换
	if (false) {
	  config.scheme = 'beta';
	} else if (false) {
	  config.scheme = 'devx';
	} else if (true) {
	  config.scheme = 'test';
	} else if (process.env.NODE_PMS == 'integrate') {
	  config.scheme = 'integrate';
	} else if (process.env.NODE_PMS == 'production') {
	  config.scheme = 'production';
	}
	module.exports = config;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	var language = 'zh-CN';
	if (window.location.search.indexOf('locale=USA') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=en') > -1) {
	  language = 'USA';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=JP') > -1) {
	  language = 'JP';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=KO') > -1) {
	  language = 'KO';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=TH') > -1) {
	  language = 'TH';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
	  language = 'zh-CN';
	  localStorage.setItem('language', language);
	} else if (window.location.search.indexOf('locale=YH') > -1) {
	  language = 'YH';
	  localStorage.setItem('language', language);
	} else {
	  localStorage.setItem('language', language);
	}
	
	module.exports = { language: language };

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	
	
	var config = __webpack_require__(1);
	config = config.env[config.scheme];
	// var xecond= config.env[config.scheme].senCond
	(function (para) {
	  //神策
	  var p = para.sdk_url,
	      n = para.name,
	      w = window,
	      d = document,
	      s = 'script',
	      x = null,
	      y = null;
	  w['sensorsDataAnalytic201505'] = n;
	  w[n] = w[n] || function (a) {
	    return function () {
	      (w[n]._q = w[n]._q || []).push([a, arguments]);
	    };
	  };
	  var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
	  for (var i = 0; i < ifs.length; i++) {
	    w[n][ifs[i]] = w[n].call(null, ifs[i]);
	  }
	  if (!w[n]._t) {
	    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
	    x.async = 1;
	    x.src = p;
	    w[n].para = para;
	    y.parentNode.insertBefore(x, y);
	  }
	})({
	  sdk_url: config.senCondjs,
	  name: 'sensors',
	  server_url: config.senCond,
	  // server_url:' http://shence.lvyuetravel.com:8107',
	  cross_subdomain: true,
	  heatmap: {
	    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
	    clickmap: 'default',
	    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
	    scroll_notice_map: 'not_collect'
	  }
	});
	sensors.registerPage({ platformType: 'pc' });
	sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(3);
	var language = localStorage.getItem('language') || 'zh-CN';
	$('body').removeClass('en');
	$('.banlan').addClass('select');
	$('.reservation').css('color', 'white');
	
	if (language == 'zh-CN') {
	    $('body').removeClass('en');
	} else {
	    $('body').addClass('en');
	}
	
	$('.commonZh').hide();
	// $('.commonJp').hide()
	$('.commonKo').hide();
	$('.commonTh').hide();
	$('.commonYh').hide();
	$('.language').on('mouseover', function () {
	    $(".choicelanguage").show();
	}).on('mouseout', function () {
	    $(".choicelanguage").hide();
	});
	$('.choicelanguage a').eq(0).on('click', function () {
	    window.location.href = window.location.origin + window.location.pathname + '?locale=zh-CN';
	    localStorage.setItem('language', 'zh-CN');
	});
	$('.choicelanguage a').eq(1).on('click', function () {
	    localStorage.setItem('language', 'USA');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=USA';
	});
	$('.choicelanguage a').eq(2).on('click', function () {
	    localStorage.setItem('language', 'JP');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=JP';
	});
	$('.choicelanguage a').eq(3).on('click', function () {
	    localStorage.setItem('language', 'KO');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=KO';
	});
	$('.choicelanguage a').eq(4).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=TH';
	});
	$('.choicelanguage a').eq(5).on('click', function () {
	    localStorage.setItem('language', 'TH');
	    window.location.href = window.location.origin + window.location.pathname + '?locale=YH';
	});
	var flagIndex = 0;
	$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
	    $('.reservationCode').fadeOut(300);
	    $('.reservation').css('opacity', 1);
	});
	
	$('.brand').addClass('select');
	$(".about1").on('mouseover', function () {
	    $(".aboutLv").show();
	});
	$(".about1").on('mouseout', function () {
	    $(".aboutLv").hide();
	});
	$(".brand1").on('mouseover', function () {
	    $(".choiceBrand").show();
	}).on('mouseout', function () {
	    $(".choiceBrand").hide();
	});
	$('.submitInfo_input_1').on('click', function () {
	    $('.select_forJoinUs').slideToggle();
	});
	$('.select_forJoinUs span').on('click', function () {
	    $('.submitInfo_input_joinUs').html($(this).html());
	});
	var width = document.documentElement.offsetWidth;
	if (width > 1920) {
	    width = 1920;
	}
	var width1 = $('.simply_container_header').width();
	$('.simply_container_header_conainer div').css({ width: width });
	$('.simply_container_header_conainer').css({ width: 7 * width });
	$(window).resize(function () {
	    //当浏览器大小变化时
	    width1 = $('.simply_container_header').width();
	    flagIndex = width1 - width;
	});
	// var step=1;
	// var $headerContainer=$('.simply_container_header_conainer');
	
	// var timer=setInterval(move,4000);
	// var moveflag = 0;
	// moveflag = -flagIndex / 2;
	// $headerContainer.css({ 'left': -width - moveflag});
	// function move(n) {
	//   moveflag=-flagIndex/2;
	//     step++;
	//     n!=undefined?step=n:null;
	//     if(step==6){
	//       $headerContainer.css('left', -width- moveflag);
	//         step=2;
	//     }
	//     $('.simply_banner li').eq(step-1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	//     if(step==5){
	//         $('.simply_banner li').eq(0).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	//     }
	//     $headerContainer.stop(false,true).animate({left:-step*width-moveflag},2500,'linear',function () {
	
	//     });
	// }
	$('.simply_container_header').on('mouseover', function () {
	    clearInterval(timer);
	});
	$('.simply_container_header').on('mouseout', function () {
	    timer = setInterval(move, 3500);
	});
	$('.simply_banner li').on('click', function () {
	    step = $('.simply_banner li').index($(this)) + 1;
	    $('.simply_banner li').eq(step - 1).addClass('simply_banner_select').siblings().removeClass('simply_banner_select');
	    $headerContainer.stop(false, true).css({ left: -step * width + -moveflag });
	});
	
	var $oImgs = $('.flowerBuilding_info_slider div');
	function flowerMove(index) {
	    $oImgs.eq(index).fadeIn(800).siblings().fadeOut(800);
	}
	$('.flowerBuilding_info_').on('click', function () {
	    var width = parseFloat($('.flowerBuilding_info').width());
	    var index1 = null;
	    for (var j = 0; j < 4; j++) {
	        var string2 = '.flowerBuilding_info_' + (j + 1);
	        if ($(string2).css('display') == "none") {
	            index1 = j;
	        }
	    }
	    var index = $('.flowerBuilding_info_').index($(this));
	    if (index1 - index == 1) {
	        $('.flowerBuilding_info_').eq(index1).css({ left: parseInt($(this).css('left')) + 100 });
	    } else if (index1 - index == -1) {
	        $('.flowerBuilding_info_').eq(index1).css({ left: parseInt($(this).css('left')) - 100 });
	    }
	    flowerMove(index);
	    $(this).hide().siblings().show();
	    if (parseFloat($(this).css("left")) > 300 || isNaN(parseFloat($(this).css("left")))) {
	        for (var i = 0; i < index + 1; i++) {
	            var string = '.flowerBuilding_info_' + (i + 1);
	            $(string).animate({ left: 100 * i }, 500);
	        }
	        for (var k = 4; k > index; k--) {
	            var string1 = '.flowerBuilding_info_' + (k + 1);
	            $(string1).animate({ left: width - 100 * (5 - k) }, 500);
	        }
	    } else {
	        for (var i = 0; i < index + 1; i++) {
	            var string = '.flowerBuilding_info_' + (i + 1);
	            $(string).animate({ left: 100 * i }, 500);
	        }
	        for (var k = 3; k >= index; k--) {
	            var string1 = '.flowerBuilding_info_' + (k + 1);
	            $(string1).animate({ left: width - 100 * (4 - k) }, 500);
	        }
	    }
	
	    $('.flowerBuilding_info_big').eq(index).siblings().slideUp();
	    setTimeout(function () {
	        $('.flowerBuilding_info_big').eq(index).slideDown();
	    }, 800);
	});
	$("img").on('dragstart', function () {
	    return false;
	});
	
	$(document).on('submit', '[data-selector="search-hotel"]', function () {
	    var cityId = $('input[name="regionId"]').val();
	    var regionType = $('input[name="regionType"]').val();
	    var startDay = $('input[data-selector="checkIn"]').val();
	    var endDay = $('input[data-selector="checkOut"]').val();
	    window.open(aihuazhuUrl + '/list/' + regionType + '/' + cityId + '?startDay=' + startDay + '&endDay=' + endDay + '&brand=' + 120);
	    return false;
	});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	// var languageType = require('./languageCommon.js')
	var languageType = __webpack_require__(2);
	var language = localStorage.getItem('language') || 'zh-CN';
	
	if (language == 'zh-CN') {
	    document.getElementsByTagName('meta')[1].setAttribute('content', tanchenmeta[language]);
	    document.getElementsByTagName('meta')[2].setAttribute('content', tanchenkey[language]);
	    document.title = tanchentitle[language];
	} else {
	    document.getElementsByTagName('meta')[1].setAttribute('content', tanchenmeta['USA']);
	    document.getElementsByTagName('meta')[2].setAttribute('content', tanchenkey['USA']);
	    document.title = tanchentitle['USA'];
	}
	
	$('.commonlanguage').html(commonlanguage[language]);
	$('title').html(tanchenTitle[language]);
	$('.commonHomePage').html(commonHomePage[language]);
	$('.commonLvyue').html(commonLvyue[language]);
	$('.commonAboutLvyue').html(commonAboutLvyue[language]);
	$('.commonlvyueBrand').html(commonlvyueBrand[language]);
	$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
	$('.commonFloralLux').html(commonFloralLux[language]);
	$('.commonClaim').html(commonClaim[language]);
	$('.commonWeiLai').html(commonWeiLai[language]);
	$('.commonTanChen').html(commonTanChen[language]);
	$('.commonBanlan').html(commonBanlan[language]);
	$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
	$('.commonPanorama').html(commonPanorama[language]);
	$('.buftlanguage1').html(buftlanguage1[language]);
	$('.decslan1').html(decslan1[language]);
	$('.buftlanguage2').html(buftlanguage2[language]);
	$('.decslan2').html(decslan2[language]);
	$('.buftlanguage3').html(buftlanguage3[language]);
	$('.decslan3').html(decslan3[language]);
	$('.aruati').html(aruati[language]);
	
	$('.commonZh').html(commonZh[language]);
	$('.commonUsa').html(commonUsa[language]);
	$('.commonJp').html(commonJp[language]);
	$('.commonKo').html(commonKo[language]);
	$('.commonTh').html(commonTh[language]);
	$('.commonYh').html(commonYh[language]);
	$('.commonflowerTravel').html(commonflowerTravel[language]);
	$('.commonReservations a').html(commonReservations[language]);
	$('.commonClose').html(commonClose[language]);
	$('.commonFreebooking').html(commonFreebooking[language]);
	$('.commonDownload').html(commonDownload[language]);
	$('.commonWechatSubscription').html(commonWechatSubscription[language]);
	$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
	$('.commonBrandintroductio').html(commonBrandintroductio[language]);
	$('.commonWantJoin').html(commonWantJoin[language]);
	$('.commonConectUs').html(commonConectUs[language]);
	$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
	$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
	$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
	$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
	$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
	$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
	$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
	$('.commonCompanyInfo').html(commonCompanyInfo[language]);
	$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
	$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
	$('.commonCompanyLicense').html(commonCompanyLicense[language]);
	$('.commonCompanyICP').html(commonCompanyICP[language]);
	$('.commonBaina').html(commonBaina[language]);
	
	$('.commonLvyue1').html(commonLvyue1[language]);
	$('.Leadership').html(Leadership[language]);
	$('.TalentRecruitment').html(TalentRecruitment[language]);
	$('.WeiLaiBuildingaboutfbType1').html(homePageSwiperFourDesignideaInfo2[language]);
	$('.WeiLaiBuildingaboutfbType3').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
	$('.floralReservation').html(floralReservation[language]);
	
	$('.beuDesign').html(beuDesign[language]);
	$('.beuDesignType1').html(beuDesignType1[language]);
	$('.beuDesignType2').html(beuDesignType2[language]);
	$('.beuDesignType3').html(beuDesignType3[language]);
	$('.beuBrandIntroductionTitle').html(beuBrandIntroductionTitle[language]);
	$('.beuBuildingaboutfbType1').html(beuBuildingaboutfbType1[language]);
	$('.beuBrandIntroductionInfo').html(beuBrandIntroductionInfo[language]);
	$('.beuBuildingaboutfbType3').html(beuBuildingaboutfbType3[language]);

/***/ })

});


// WEBPACK FOOTER //
// js/beu.ef5ac49f.js